import React from "react";
import { Link } from "react-router-dom";

const CATEGORIES = [
  { label: "Wedding",          to: "/choose-wedding-template",   img: require("./Logos/Wedding.png") },
  { label: "Save the Date",    to: "/choose-save-date-template", img: require("./Logos/SaveDate.png") },
  { label: "Bridal Shower",    to: "/choose-shower-template",    img: require("./Logos/BridalShower.png") },
  { label: "Baby",             to: "/choose-baby-template",      img: require("./Logos/Baby.png") },
  { label: "Social Distancing",to: "/comingsoon",                img: require("./Logos/SocialDistancing.png") },
  { label: "Birthday",         to: "/comingsoon",                img: require("./Logos/Birthday.png") },
];

export default function Overview() {
  return (
    <section id="overview" className="pc-section papercraft">
      <header className="pc-section__head">
        <span className="pc-eyebrow">For every gathering</span>
        <h2 className="pc-section__title">
          Effortless online invitations,<br />
          delivered with <em style={{ fontStyle: "italic", color: "var(--pc-terracotta)" }}>care</em>.
        </h2>
        <p className="pc-section__lede">
          Send elegant invitations directly to friends and family — complete with a
          personalized digital envelope, liner, stamp, and RSVP tracking. Choose a
          designer suite or upload your own.
        </p>
      </header>

      <div className="pc-cards">
        {CATEGORIES.map((c) => (
          <Link key={c.label} to={c.to} className="pc-card">
            <img className="pc-card__image" src={c.img} alt="" />
            <span className="pc-card__label">{c.label}</span>
            <span className="pc-card__rule" aria-hidden />
          </Link>
        ))}
      </div>
    </section>
  );
}
